import React from 'react'

const CancellationAndRefund = () => {
    return (
        <div className='page-content'>
            <div className="container">
                <div className="row content-layout-wrapper align-items-start">
                    <div className="site-content col-lg-12 col-12 col-md-12" role="main">
                        <article id="post-21216" className="post-21216 page type-page status-publish hentry">
                            <div className="entry-content">
                                <div className="elementor elementor-21216">
                                    <div
                                        className="wd-negative-gap elementor-element elementor-element-796e0e9 e-flex e-con-boxed e-con e-parent"
                                        data-id="796e0e9"
                                        data-element-type="container"
                                        data-settings='{"content_width":"boxed"}'
                                        data-core-v316-plus="true"
                                    >
                                        <div className="e-con-inner">
                                            <div
                                                className="elementor-element elementor-element-303bc43 elementor-widget elementor-widget-wd_text_block"
                                                data-id="303bc43"
                                                data-element-type="widget"
                                                data-widget-type="wd_text_block.default"
                                            >
                                                <div className="elementor-widget-container">
                                                    <div className="wd-text-block reset-last-child text-left">
                                                        {/* <h1>Cancellation and Refund Policy</h1> */}

                                                        <h2>Cancellation Policy</h2>
                                                        <p>
                                                            At Wwings Smart Tech Pvt. Ltd., we understand that circumstances may arise which may change your plans.
                                                            Keeping that in mind, we have designed our cancellation policy to be as flexible as possible.
                                                        </p>
                                                        <ul>
                                                            <li>
                                                                <p>
                                                                    For services not yet initiated, customers can cancel their order within 24 hours of placing the order.
                                                                    Please notify us of your intent to cancel by emailing us at{' '}
                                                                    <a href="mailto:support@wwingstech.com">support@wwingstech.com</a>.
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p>
                                                                    For ongoing services, we require a notice period of 7 days for cancellation.
                                                                    The cancellation will take effect from the day we receive your email.
                                                                </p>
                                                            </li>
                                                        </ul>

                                                        <h2>Refund Policy</h2>
                                                        <p>
                                                            We place customer satisfaction at the center of our operations.
                                                            If you are not satisfied with our services, the following will apply:
                                                        </p>
                                                        <ul>
                                                            <li>
                                                                <p>
                                                                    If you cancel your order within 24 hours of placing it and before the service initiation,
                                                                    you are eligible for a full refund.
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p>
                                                                    For ongoing services, refunds will be prorated based on the amount of work completed at the time of cancellation.
                                                                    The refund amount will be the total payment made minus the charges for the work already completed.
                                                                </p>
                                                            </li>
                                                            <li>
                                                                <p>Refund will be processed within 15 working days from the date of cancellation.</p>
                                                            </li>
                                                            <li>
                                                                <p>All refunds will be credited to the original method of payment.</p>
                                                            </li>
                                                        </ul>

                                                        <p>
                                                            Please note that this policy may not apply to third-party services offered on our platform.
                                                            For such services, the respective third-party's cancellation and refund policy will apply.
                                                        </p>
                                                        <p>
                                                            We reserve the right to modify this cancellation and refund policy at any time, so please review it frequently.
                                                            Changes and clarifications will take effect immediately upon their posting on our website.
                                                        </p>
                                                        <p>
                                                            If you have any questions regarding our cancellation and refund policy,
                                                            please email us at{' '}
                                                            <a href="mailto:support@wwingstech.com">support@wwingstech.com</a>
                                                        </p>

                                                        <p><strong>By using our services, you signify your acceptance to our Cancellation and Refund Policy.</strong></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CancellationAndRefund